export default __webpack_public_path__ + "static/media/upload.bd4726b7.svg";